import React, { useState } from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import {
  useAddManpowerRQMTMutation,
  useUpdateManpowerRQMTMutation,
} from './manpowerrqmtApiSlice';
import Notification from '../../components/common/Notification';

const AddManpowerRQMT = ({ data, isEdit, onClose }) => {
  const [addManpowerRQMT, { isLoading }] = useAddManpowerRQMTMutation();
  const [updateManpowerRQMT] = useUpdateManpowerRQMTMutation();
  const [errMsg, setErrMsg] = useState('');
  const [showNotification, setShowNotification] = useState(false);

  const initialValues = {
    id: data?.id || '',
    name: data?.name || '',
    description: data?.desc || '',
  };
  const validationSchema = yup.object({
    details: yup.string().required('Please enter Manpower Requirement details'),
    Requirement: yup.string().required('Please enter Requirement'),
  });
  const onSubmit = async (validationSchema) => {
    try {
      if (isEdit) {
        const accountData = await updateManpowerRQMT(validationSchema).unwrap();
      } else {
        const accountData = await addManpowerRQMT(validationSchema).unwrap();
        formik.values.name = '';
        formik.values.description = '';
      }
      setShowNotification(!showNotification);
      // onClose();
    } catch (error) {}
  };
  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
  });
  return (
    <>
      <Notification isShow={showNotification} />

      <form
        onSubmit={formik.handleSubmit}
        className="flex flex-col justify-between"
      >
        <div className="flex justify-between border-b-2 border-gray-200">
          <div className=" items-center">
            <h4 className="text-xl">Chennai</h4>
            <h5 className="mb-3 text-sm font-normal tracking-tight text-gray-900">
              Anna Nagar
            </h5>
          </div>
          <div>
            <strong className="flex w-full text-4xl font-medium text-purple-700">
              75
            </strong>
          </div>
        </div>

        <div className="space-y-1 mt-5 border-b-2 border-gray-200">
          <h2 className="mb-2 text-lg font-bold tracking-tight text-purple-900">
            Requested by
          </h2>
          <h3 className="mb-2 text-md font-normal tracking-tight text-black">
            Robin Williams
          </h3>
          <p className="mb-2 text-sm pb-3 font-normal tracking-tight text-gray-500">
            HR Department Head
          </p>
        </div>

        {/* <div className="space-y-1 mt-5">
          <h5 className="mb-2 text-sm font-normal tracking-tight text-gray-900">
            Asign To *
          </h5>
          <select
            id="region"
            name="region"
            autoComplete="region"
            className="bg-inputbg border border-inputBorder mt-1 block w-full rounded-md  py-2 px-3  focus:border-purplecolor-100 focus:outline-none sm:text-sm"
          >
            <option>
              Robin Williams
              <br />
            </option>
            <option>John</option>
            <option>Williams</option>
          </select>
        </div> */}

        <div className="space-y-1 pt-5">
          <h5 className="mb-2 text-sm font-normal tracking-tight text-gray-900">
            Notes *
          </h5>
          <label htmlFor="description" className="sr-only">
            Notes
          </label>
          <textarea
            rows={8}
            name="notes"
            id="notes"
            className="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
            // defaultValue={''}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.notes}
          />
          {formik.touched.notes && formik.errors.notes ? (
            <div className="mt-2 text-sm text-red-600">
              {formik.errors.notes}
            </div>
          ) : null}
          <div className="flex flex-shrink-0 justify-between py-4">
            <button
              type="button"
              className=" rounded-lg  bg-queryBlue text-white py-1 px-6 mr-3 text-sm font-medium  shadow-sm focus:outline-none "
              onClick={onClose}
            >
              Query
            </button>
            <button
              type="button"
              className=" rounded-lg border border-red-600 bg-red-600 py-1 px-6 mr-3 text-sm font-medium text-white shadow-sm  focus:outline-none"
              onClick={onClose}
            >
              Reject
            </button>
            {isLoading ? (
              <button
                type="submit"
                disabled
                className="inline-flex justify-center rounded-3xl border border-transparent bg-violet-900 py-3 px-8 text-sm font-medium text-white shadow-sm focus:outline-none"
              >
                <svg
                  role="status"
                  className="inline mr-3 w-4 h-4 text-white animate-spin"
                  viewBox="0 0 100 101"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="#E5E7EB"
                  />
                  <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentColor"
                  />
                </svg>
                Loading...
              </button>
            ) : (
              <button
                disabled={!(formik.dirty && formik.isValid)}
                type="submit"
                className="inline-flex justify-center rounded-lg border border-transparent bg-approve py-1 px-6 text-sm font-medium text-white shadow-sm  focus:outline-none"
              >
                Approve
              </button>
            )}
          </div>
        </div>

        {/* <div className="space-y-1 pt-5">
          <h5 className="mb-2 text-sm font-normal tracking-tight text-gray-900">
            Notes *
          </h5>
          <label htmlFor="description" className="sr-only">
            Notes
          </label>
          <textarea
            rows={8}
            name="notes"
            id="notes"
            className="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.notes}
          />

          {formik.touched.notes && formik.errors.notes ? (
            <div className="mt-2 text-sm text-red-600">
              {formik.errors.notes}
            </div>
          ) : null}
          <div className="flex flex-shrink-0 justify-end py-4">
            <button
              type="button"
              className=" rounded-3xl border border-gray-300 bg-white py-3 px-8 mr-3 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
              onClick={onClose}
            >
              Cancel
            </button>
            {isLoading ? (
              <button
                type="submit"
                disabled
                className="inline-flex justify-center rounded-3xl border border-transparent bg-violet-900 py-3 px-8 text-sm font-medium text-white shadow-sm hover:bg-violet-700 disabled:bg-violet-400 focus:outline-none"
              >
                <svg
                  role="status"
                  className="inline mr-3 w-4 h-4 text-white animate-spin"
                  viewBox="0 0 100 101"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="#E5E7EB"
                  />
                  <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentColor"
                  />
                </svg>
                Loading...
              </button>
            ) : (
              <button
                disabled={!(formik.dirty && formik.isValid)}
                type="submit"
                className="inline-flex justify-center rounded-3xl border border-transparent bg-violet-900 py-3 px-8 text-sm font-medium text-white shadow-sm hover:bg-violet-700 disabled:bg-violet-400 focus:outline-none"
              >
                Save
              </button>
            )}
          </div>
        </div> */}
      </form>
    </>
  );
};

export default AddManpowerRQMT;
